import React from "react";
import { Grid, Card, Box, Typography } from "@mui/material";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import AddCardOutlinedIcon from "@mui/icons-material/AddCardOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import NorthEastOutlinedIcon from "@mui/icons-material/NorthEastOutlined";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import COLORS from "../../../../../constants/colors";

const SummaryCards = ({ summaryData }) => {
    const cardData = [
        {
            title: "Available Balance",
            value: `UGX ${Math.trunc(summaryData?.userBalance || 0).toLocaleString()}`,
            icon: <AccountBalanceWalletOutlinedIcon sx={{ color: COLORS.primary }} />,
            color: "#e3f2fd",
        },
        {
            title: "Membership & Event Income",
            value: `UGX ${Math.trunc(summaryData?.membershipRaised || 0).toLocaleString()}`,
            icon: <ConfirmationNumberOutlinedIcon sx={{ color: "#7b1fa2" }} />,
            color: "#f3e5f5",
        },
        {
            title: "Total Goal",
            value: `UGX ${Math.trunc(summaryData?.totalGoal || 0).toLocaleString()}`,
            icon: <AddCardOutlinedIcon sx={{ color: "green" }} />,
            color: "#e8f5e9",
        },
        {
            title: "Total Raised",
            value: `UGX ${Math.trunc(summaryData?.totalRaised || 0).toLocaleString()}`,
            icon: <PaidOutlinedIcon sx={{ color: "blue" }} />,
            color: "#e0f2f1",
        },
        {
            title: "Total Withdrawn",
            value: `UGX ${Math.trunc(summaryData?.totalWithdrawn || 0).toLocaleString()}`,
            icon: <NorthEastOutlinedIcon sx={{ color: "red" }} />,
            color: "#ffebee",
        },
    ];

    return (
        <Box sx={{ mt: 3 }}>
            <Grid container spacing={2}>
                {cardData.map((item, index) => (
                    <Grid item xs={12} sm={6} md={2.4} key={index}>
                        <Card
                            sx={{
                                p: 2,
                                display: "flex",
                                alignItems: "center",
                                borderRadius: 2,
                                boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                                border: `1px solid ${COLORS.border}`,
                            }}
                        >
                            <Box
                                sx={{
                                    p: 1.5,
                                    borderRadius: "50%",
                                    bgcolor: item.color,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    mr: 2,
                                    flexShrink: 0,
                                }}
                            >
                                {item.icon}
                            </Box>
                            <Box>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ fontWeight: 600, fontSize: "0.85rem" }}
                                >
                                    {item.title}
                                </Typography>
                                <Typography variant="h6" fontWeight="bold">
                                    {item.value}
                                </Typography>
                            </Box>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default SummaryCards;
